<div class="pwa-banner" *ngIf="showInstallBanner">
  <span class="material-icons pwa-banner-icon">get_app</span>
  <div class="pwa-banner-body">
    <div class="pwa-banner-title">Install REEV Admin</div>
    <div class="pwa-banner-desc">Add this app to your device for quick, full-screen access.</div>
  </div>
  <div class="pwa-banner-actions">
    <button class="btn-secondary btn-sm" (click)="dismissInstall()">Not now</button>
    <button class="btn-primary btn-sm" (click)="installApp()">Install</button>
  </div>
</div>

<div class="pwa-banner" *ngIf="showIosBanner">
  <span class="material-icons pwa-banner-icon">ios_share</span>
  <div class="pwa-banner-body">
    <div class="pwa-banner-title">Install REEV Admin</div>
    <div class="pwa-banner-desc">Tap the Share icon, then "Add to Home Screen".</div>
  </div>
  <div class="pwa-banner-actions">
    <button class="btn-secondary btn-sm" (click)="dismissInstall()">Got it</button>
  </div>
</div>

<div class="pwa-banner pwa-banner-update" *ngIf="showUpdateBanner">
  <span class="material-icons pwa-banner-icon" [class.pwa-spin]="updating">autorenew</span>
  <div class="pwa-banner-body">
    <div class="pwa-banner-title">Update available</div>
    <div class="pwa-banner-desc">A new version of REEV Admin is ready.</div>
  </div>
  <div class="pwa-banner-actions">
    <button class="btn-primary btn-sm" (click)="updateApp()" [disabled]="updating">
      {{ updating ? 'Updating…' : 'Reload' }}
    </button>
  </div>
</div>
